import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'news'
}
